import { ParamsBuilder } from "../types";
import { RowState } from "../types";

export class JSONBuilder implements ParamsBuilder {
  build(row: RowState): object {
    const isArray = Array.isArray(row.value);
    switch (row.operator) {
      case "equals":
        return { [row.fieldName]: { path: row.jsonPath, equals: isArray ? row.value[0] : row.value } };

      case "notEquals":
        return {
          NOT: { [row.fieldName]: { path: row.jsonPath, equals: isArray ? row.value[0] : row.value } }
        };
      case "containsAny":
        if (!isArray)
          return { [row.fieldName]: { path: row.jsonPath, equals: isArray ? row.value[0] : row.value } };
        return {
          OR: (row.value as any[]).map((v) => ({ [row.fieldName]: { path: row.jsonPath, equals: v } }))
        };
      default:
        return {};
    }
  }
}
